
import { 
    claimGadgetModelSet, 
    claimGadgetMakeSet, 
    claimDocumentUploaded, 
    claimRelatedReferenceSet, 
    claimHasWebUser, 
    claimHasPolicy, 
    claimAllValidationPipelinesPassed, 
    claimValidationPipelineRun, 
    //claimPolicyholderClaimantMatch 
} from './claimRules.js'

import { claimantIsPolicyholder } from './claimantRules.js'

let claimWarningsPipeline = {
    id: 3,
    name: 'claimWarningPipeline',
    rules: [
        claimGadgetMakeSet,
        claimGadgetModelSet,
        claimDocumentUploaded,
        claimRelatedReferenceSet,
        claimHasPolicy,
        claimHasWebUser,        
        claimAllValidationPipelinesPassed,
        claimValidationPipelineRun,
        claimantIsPolicyholder,
        //claimPolicyholderClaimantMatch
    ]
}

export { claimWarningsPipeline }